﻿import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Row, Col } from "react-bootstrap";

import classes from "./login.module.scss";
import { ReactComponent as LogoSvg } from "@/assets/images/mobile/logo-agro.svg";

import Fetching from "@/components/Fetching/Fetching";

import { authForgotPassword } from "@/redux/actions/auth.actions";
import { validateEmail } from "@/services/Utils";
import { FINAL_LOGIN_REQUEST } from "@/redux/types/auth.types";

const ForgotPassword = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { addToast } = useToasts();
	const { isFetching } = useSelector((state) => state.auth);
	const token = localStorage.getItem("token");

	const [email, setEmail] = useState("");

	if (token) {
		return <Navigate to="/" replace />;
	}

	const handleClickImage = () => {
		dispatch({ type: FINAL_LOGIN_REQUEST });
		navigate("/");
	};

	const handleForgotPassword = (e) => {
		e.preventDefault();
		e.stopPropagation();

		let validate = true;
		if (!email) {
			validate = false;
			addToast("Debe ingresar su email para solicitar su contraseña.", {
				appearance: "error",
			});
		}
		if (!validateEmail(email) && email) {
			validate = false;
			addToast("Debe ingresar una dirección de email valida.", {
				appearance: "error",
			});
		}

		if (validate) {
			dispatch(authForgotPassword(email)).then(() => {
				navigate("/");
			});
		}
	};

	const handleKeyPress = (e) => {
		const keyCode = e.which || e.keyCode;
		if (keyCode === 13) {
			handleForgotPassword(e);
		}
	};

	if (isFetching) {
		return <Fetching />;
	}

	return (
		<div className={classes.loginGlobal}>
			<Row className={classes.main}>
				<Col sm={12} className={classes.header}>
					<LogoSvg className="logo" onClick={() => handleClickImage()} />
				</Col>

				<Col sm={12} className={classes.form}>
					<Row>
						<Col sm={12} className={classes.title}>
							RESTABLECER CONTRASEÑA
						</Col>

						<Col className={classes.inputContent} sm={12}>
							<input
								className={classes.input}
								type="text"
								placeholder="Email"
								value={email}
								onChange={(e) => setEmail(e.currentTarget.value)}
								onKeyPress={(e) => handleKeyPress(e)}
							/>
						</Col>
					</Row>
				</Col>

				<Col sm={12} className={classes.submit} onClick={(e) => handleForgotPassword(e)}>
					Recuperar Contraseña
				</Col>

				<Col sm={12} className={classes.forgotPassword} onClick={() => navigate("/acceso")}>
					Iniciar sesión
				</Col>
			</Row>
		</div>
	);
};

export default ForgotPassword;
